<div class="section" id="reference">
        <div class="container cc-reference">
          <div class="h4 mb-4 text-center title">References</div>
          <div class="card" data-aos="zoom-in">
            <div class="carousel slide" id="cc-Indicators" data-ride="carousel">
              <ol class="carousel-indicators">
                <li class="active" data-target="#cc-Indicators" data-slide-to="0"></li>
                <li data-target="#cc-Indicators" data-slide-to="2"></li>
               
              </ol>
              <div class="carousel-inner">
                <div class="carousel-item active">
                  <div class="row">

                    <div class="col-lg-12 col-md-9">
                    <p>
                      Awesome therapist. I have been through quite a few therapist looking for the right one.</p><p> Tracie is very empathetic and easy to talk to. She processes info very quickly and assists me in finding solutions to problems. </p><p>I highly recommend her.
                    </p>

                    <div class="h5 mt-1">-Jack Sherry</div>
                    </div>
                  </div>
                </div>
                <div class="carousel-item">
                  <div class="row">

                    <div class="col-lg-10 col-md-9">
                      <p> Awesome therapist, easy to speak with.</p><p> Caring and nurturing,</p><p> I would highly reccomend.
                      </p>

                         <div class="h5 mt-1">-Hetal </div>
                    </div>
                  </div>
                </div>
                <div class="carousel-item">
                  <div class="row">
                    

                    <div class="col-lg-10 col-md-9">
                      <p> I started working with Tracie this year and she’s been immensely helpful. 
                      </p><p> She is empathetic and offers practical advice. 
                      </p><p> There is a lot of paperwork at the beginning, but it’s because she’s very thorough. 
                      </p><p> She was also very helpful with sorting out a problem with my insurance coverage. 
 
                      </p><p> Scheduling and communications have been a smooth process.
                      </p>

                         <div class="h5 mt-1">-Hetal </div>
                    </div>
                  </div>
                </div>
                <div class="carousel-item">
                  <div class="row">

                    <div class="col-lg-10 col-md-9">
                      <p> Awesome therapist, easy to speak with.</p><p> Caring and nurturing,</p><p> I would highly reccomend.
                      </p>

                         <div class="h5 mt-1">-Hetal </div>
                    </div>
                  </div>
                </div>
                <div class="carousel-item">
                  <div class="row">

                    <div class="col-lg-10 col-md-9">
                      <p> Awesome therapist, easy to speak with.</p><p> Caring and nurturing,</p><p> I would highly reccomend.
                      </p>

                         <div class="h5 mt-1">-Hetal </div>
                    </div>
                  </div>
                </div>
               
              </div>
            </div>
          </div>
        </div>
      </div>